import { useNavigate } from 'react-router-dom';
import { useLogoutMutation } from '../../api/LoginAPI';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../Store';
import { setLogout } from '../../Slice/AuthSlice';

interface ThisProps {
  //  uidAuftrag: string;
}

/**
 * @author noone
 */
const LogoutButtonComponent: React.FC<ThisProps> = ({ }) => {

  const [logoutAPI] = useLogoutMutation();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  return (
    <>
      <style>
        {`
          .logout-icon {
            cursor: pointer;
            color: red;
            transition: all 0.2s ease;
          }

          .logout-icon:hover {
            color: #ff9191;
            transform: scale(5);
            text-shadow: 0 0 8px rgba(255, 0, 0, 0.6);
          }
        `}
      </style>
      <span title="Logout" onClick={() =>
        logoutAPI()
          .then(() => dispatch(setLogout()))
          .then(() => navigate('/'))}>

        <i className='bi bi-power logout-icon' ></i>
      </span>
    </>
  );

}

export default LogoutButtonComponent;